import clsx from "clsx";
import type { GuildBattleOutcome } from "../../utils/guildBattleResult";

interface GuildBattleResultOverlayProps {
  outcome: GuildBattleOutcome;
  title?: string;
  subtitle?: string;
  confirmLabel?: string;
  onConfirm: () => void;
}

export function GuildBattleResultOverlay({
  outcome,
  title,
  subtitle,
  confirmLabel = "OK",
  onConfirm,
}: GuildBattleResultOverlayProps) {
  const defaultTitle =
    outcome === "victory" ? "Victory!" : outcome === "defeat" ? "Defeat" : "Battle Over";

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/75 backdrop-blur-sm">
      <div className="mx-6 w-full max-w-sm rounded-2xl border border-kingdom-mid bg-kingdom-purple p-6 text-center space-y-4 shadow-2xl">
        <p
          className={clsx(
            "text-3xl font-bold font-game",
            outcome === "victory" && "text-emerald-400",
            outcome === "defeat" && "text-rose-400",
            outcome === "spectator" && "text-amber-200",
          )}
        >
          {title ?? defaultTitle}
        </p>
        {subtitle && <p className="text-sm text-gray-300">{subtitle}</p>}
        <button
          type="button"
          onClick={onConfirm}
          className="w-full py-3 rounded-xl bg-kingdom-mid text-white font-bold text-sm hover:bg-kingdom-glow/30 transition-colors"
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  );
}
